// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.svg-icon[data-v-54f74f74] {\n  width: 58px;\n  height: 58px;\n}\n.svg-icon .icon-fill-color[data-v-54f74f74] {\n  fill: var(--primary-color);\n}\n", ""]);
// Exports
module.exports = exports;
